module.exports = __webpack_public_path__ + "img/gnzs1.8ff7701a.png";